import { render, staticRenderFns } from "./ClientesOrdensServico.vue?vue&type=template&id=7bba2f8b&scoped=true&"
import script from "./ClientesOrdensServico.vue?vue&type=script&lang=js&"
export * from "./ClientesOrdensServico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bba2f8b",
  null
  
)

export default component.exports